import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  codes : [],
  codeData : null,
  codeMessage : null,
  businessClients : null,
  error : null
};


export const CODE_URL = "/admin/code";

export const getCodes = createAsyncThunk(
    CODE_URL + "/get",
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.get(CODE_URL, {
          params: formData
        });
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

export const getCodeById = createAsyncThunk(
  CODE_URL + "/get-by-id",
  async (id, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(`${CODE_URL}/view/${id}`);
      if (response.data) {
        return response.data?.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const createCode = createAsyncThunk(
    CODE_URL + "/create",
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.post(CODE_URL, formData);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

export const updateCode = createAsyncThunk(
  CODE_URL + "/update",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(CODE_URL + "/update/" + formData?.id, formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const deleteCode = createAsyncThunk(
  CODE_URL + '/delete',
  async (id, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      // const id = formData.get('id')
      const response = await axiosInstance.delete(CODE_URL + '/' + id);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getBusinessClients = createAsyncThunk(
  CODE_URL + '/business-clients',
  async (id, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(CODE_URL + '/business-clients');
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

const codeSlice = createSlice({
    name : "code",
    initialState,
    extraReducers : (builder) => {
        builder
            .addCase(getCodes.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getCodes.fulfilled, (state, action) => {
                state.isLoading = false;
                state.codes = action.payload;
            })
            .addCase(getCodes.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(getCodeById.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(getCodeById.fulfilled, (state, action) => {
                state.isLoading = false;
                state.codeData = action.payload;
            })
            .addCase(getCodeById.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(createCode.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createCode.fulfilled, (state, action) => {
                state.isLoading = false;
                state.codeData = action.payload;
            })
            .addCase(createCode.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(updateCode.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(updateCode.fulfilled, (state, action) => {
                state.isLoading = false;
                state.codeData = action.payload;
            })
            .addCase(updateCode.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(deleteCode.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(deleteCode.fulfilled, (state, action) => {
                state.isLoading = false;
                state.codeMessage = action.payload;
            })
            .addCase(deleteCode.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(getBusinessClients.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(getBusinessClients.fulfilled, (state, action) => {
                state.isLoading = false;
                state.businessClients = action.payload;
            })
            .addCase(getBusinessClients.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(logout, () => initialState)
    }
})

export default codeSlice.reducer